/**
* Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.marquee__marquee' ).length ) {
        $( '.marquee__marquee' ).each( function( index, element ) {
          const textWidth = $( element ).find( '.marquee__slide-text' ).outerWidth();
          const section = $( this );
          const doubleWidth = section.width() * 2; const max = 10;
          let totalWidth = 0; let iterations = 0;
          const track = section.find( element );
          const slides = track.find( '.marquee__slide-text' );

          slides.each( ( _, el ) => totalWidth += $( el ).outerWidth() );
          while ( totalWidth < doubleWidth && iterations++ < max ) {
            slides.each( ( _, el ) => {
              const clone = $( el ).clone();
              track.append( clone );
              totalWidth += clone.width();
            } );
          }
          new Splide( element, {
            type: 'loop',
            fixedWidth: `${textWidth}px`,
            gap: '2rem',
            autoScroll: {
              speed: 1,
              pauseOnHover: false,
            },
            arrows: false,
            pagination: false,
          } ).mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'marquee', COMPONENT );
} )( app );
